import { render, staticRenderFns } from "./mdInSubmitTo.vue?vue&type=template&id=4bcd6a22&scoped=true"
import script from "./mdInSubmitTo.vue?vue&type=script&lang=js"
export * from "./mdInSubmitTo.vue?vue&type=script&lang=js"
import style0 from "./mdInSubmitTo.vue?vue&type=style&index=0&id=4bcd6a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd6a22",
  null
  
)

export default component.exports